import { Event } from '@/types/zod.schemas';
import { toLogicDate } from '@/utils/date-utils';

/**
 * Filter events for a specific day.
 * HARDENED: Uses toLogicDate (string matching) to prevent UTC shifting regressions.
 */
export const filterEventsByDate = (allEvents: Event[], selectedDate: Date) => {
    const selectedStr = toLogicDate(selectedDate);
    return (allEvents || []).filter(e => toLogicDate(e.start_time) === selectedStr);
};

/**
 * Generates style metadata for calendar day cells.
 */
export const getDateStyle = (date: Date, allEvents: Event[]) => {
    const dayEvents = filterEventsByDate(allEvents, date);
    const hasActivity = dayEvents.length > 0;
    const isToday = toLogicDate(date) === toLogicDate(new Date());

    return {
        color: isToday ? '#2ecc71' : (hasActivity ? '#f29b11' : (date.getDay() === 0 || date.getDay() === 6 ? '#444' : '#666')),
        fontWeight: (isToday || hasActivity) ? '900' : '800',
        opacity: 1, 
        markers: dayEvents.map((e: Event) => ({ type: e.type, status: e.status })),
        hasActivity, 
        isToday
    };
};
